import { HStack } from '@chakra-ui/react';

import { Loader } from 'shared';
import Box from 'shared_DEPRECATED/components/Box/Box';

import { Typography } from 'shared/components/Typography';

export default function ChatReconnectionIndicator() {
  return (
    <Box
      style={{
        position: 'absolute',
        zIndex: 12,
        width: '100%',
        top: '50px',
        left: '0',
        right: '0',
        background: 'var(--bgCompWarning)',
      }}
    >
      <HStack w="200px" m="0 auto" pb={2}>
        <Loader data-testid="loader-reconnection" />
        <Typography type="body" color="black" whiteSpace="nowrap">
          Waiting for network
        </Typography>
      </HStack>
    </Box>
  );
}
